import {useSelector} from 'react-redux'
import {getSearchParameters} from 'modules/sapiSearch/selectors'
import {getNumberOfNights} from 'utils/offers'

import {Box} from '@daedalus/atlas/helpers/Box'
import {Icon} from '@daedalus/atlas/Icon'
import {Text} from '@daedalus/atlas/Text'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import {roomLabels} from '@daedalus/core/src/offer/business/getRoomLabels'
import {roomsToConfigurationObject} from '@daedalus/core/src/room/business/roomConfiguration'

export const RoomOfferSelectedLabel = ({
  showFullText = false
}: {
  showFullText?: boolean
}) => {
  const {rooms, checkIn, checkOut} = useSelector(getSearchParameters) || {}
  const numberOfNights = getNumberOfNights(checkIn, checkOut)
  const {numberOfAdults, numberOfChildren} = roomsToConfigurationObject(rooms)

  return (
    <Box
      display="flex"
      alignItems="center"
      gap="s200"
      color="content.success.c600"
    >
      <Icon name="ArrowDown" size="sm" />
      <Text variant="labelS">
        {!showFullText ? (
          <FormattedMessageWrapper
            id={roomLabels.yourSelection.id}
            defaultMessage={roomLabels.yourSelection.defaultMessage}
          />
        ) : (
          <FormattedMessageWrapper
            id="splitBooking.selectedLabel"
            defaultMessage="Your selection for {numberOfNights, plural, one {1 night} other {# nights}}{numberOfAdults, plural, =0 {} one {, 1 adult} other {, # adults}}{numberOfChildren, plural, =0 {} one {, 1 child} other {, # children}}:"
            values={{
              numberOfNights,
              numberOfAdults,
              numberOfChildren
            }}
          />
        )}
      </Text>
    </Box>
  )
}
